import { Row, Input,} from "antd";
import { useState, useEffect } from "react";
import { } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
export const InputCustomDate = ({
  tipo,
  idCampo,
  nombreCampo,
  elValue,
  elPlaceholder,
  required,
  tipoError,
  error,
  onChange,
  min,
  max
}) => {
  const [value, setValue] = useState();
  const [showPassword, setShowPassword] = useState(false);
    // Función para alternar la visibilidad de la contraseña
    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };
  
  // console.log("onChange prop:", onChange)
  let esRequired = required ? "*" : "";

  useEffect(() => {
    setValue(elValue !== "" ? elValue : undefined);
  }, [elValue]);
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setValue(value); // Actualiza el estado local con el nuevo valor
    onChange({ target: { value: value, id: id } }); // Simula un evento y pasa el nuevo valor a la función onChange
  };
  return (
    <Row justify={"left"}>
      <label htmlFor={idCampo}>
        <p className="nombre-campo">
          {nombreCampo} {esRequired}
        </p>
      </label>
      
      <Input
        className="input-component"
        autoComplete="none"
        id={idCampo}
        type={tipo === "password" && showPassword ? "text" : tipo}
        placeholder={elPlaceholder}
        onChange={handleInputChange}
        value={value}
        min={min}
        max={max}
        required={required}
        status={tipoError}
        suffix={
          tipo === "password" && (
            <span
              onClick={togglePasswordVisibility}
              style={{ cursor: "pointer" }}
            >
              {showPassword ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
            </span>
          )
        }
      />
      <span className="spanErrores" style={{ color: "red" }}>
        <b>{error}</b>
      </span>
    </Row>
  );
};
